import { useEffect, useState } from 'react'
import useApplicationSetting from './useApplicationSetting'

const useStateAppSetting = (field, parser = setting => setting, defaultValue) => {
    const appSetting = useApplicationSetting(field, parser)
    const [setting, setSetting] = useState(appSetting ?? defaultValue)

    const initSetting = () => setSetting(appSetting ?? defaultValue)

    useEffect(() => {
        initSetting()
    }, [appSetting])

    return [setting, setSetting, initSetting]
}

export default useStateAppSetting